var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3List,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Sponsor",
                                      prop: "sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.sponsorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "sponsorName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.sponsorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "ASL Group",
                                      prop: "aslGroupName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.aslGroupName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "aslGroupName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.aslGroupName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "药品一级分类",
                                      prop: "medicineLevelOneGrade",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition
                                              .medicineLevelOneGrade,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "medicineLevelOneGrade",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.medicineLevelOneGrade",
                                        },
                                      },
                                      _vm._l(
                                        _vm.medicineLevelOneGradeList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "WHO 分类",
                                              prop: "medicineLevelTwoGrade",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .medicineLevelTwoGrade,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "medicineLevelTwoGrade",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.medicineLevelTwoGrade",
                                                },
                                              },
                                              _vm._l(
                                                _vm.medicineLevelTwoGradeList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "OIE 药物等级",
                                              prop: "oieMedicineGrade",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  filterable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .oieMedicineGrade,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "oieMedicineGrade",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.oieMedicineGrade",
                                                },
                                              },
                                              _vm._l(
                                                _vm.oieMedicineGradeList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "有效成分",
                                              prop: "effectiveComponents",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .effectiveComponents,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "effectiveComponents",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.effectiveComponents",
                                                },
                                              },
                                              _vm._l(
                                                _vm.effectiveComponentsList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "通用名",
                                              prop: "commonName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition.commonName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "commonName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.commonName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "商品名",
                                              prop: "productName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "药品状态",
                                              prop: "medicineUseStatus",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table:
                                                  "TT_RMC_PROTEIN_MEDICINE",
                                                filterable: "",
                                                field: "MEDICINE_USE_STATUS",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .medicineUseStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "medicineUseStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.medicineUseStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "提交时间从",
                                              prop: "submitDateFrom",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .submitDateFrom,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "submitDateFrom",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.submitDateFrom",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "提交时间至",
                                              prop: "submitDateTo",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .submitDateTo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "submitDateTo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.submitDateTo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.queryData },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "500",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交时间",
                field: "submitDate",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "修改原因",
                field: "modifyReason",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "药品状态",
                field: "medicineUseStatusI18n",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                field: "category3Name",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Sponsor",
                "min-width": "100",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "ASL Group",
                "min-width": "120",
                field: "aslGroupName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "药品一级分类",
                "min-width": "140",
                field: "medicineLevelOneGrade",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "WHO分类",
                "min-width": "100",
                field: "medicineLevelTwoGrade",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "WHO药品等级",
                "min-width": "120",
                field: "whoMedicineGrade",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "OIE药物等级",
                "min-width": "100",
                field: "oieMedicineGrade",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "有效成分",
                "min-width": "120",
                field: "effectiveComponents",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "通用名",
                "min-width": "120",
                field: "commonName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "商品名",
                "min-width": "120",
                field: "productName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "兽药批准文号",
                "min-width": "120",
                field: "approvelNumber",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "有效成分和含量",
                "min-width": "120",
                field: "effectiveComponentsContent",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "适应症",
                "min-width": "120",
                field: "indication",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "生产厂家",
                "min-width": "120",
                field: "producer",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "规格",
                "min-width": "120",
                field: "specification",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "用法和用量",
                "min-width": "120",
                field: "usage",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "休药期(天)",
                "min-width": "120",
                field: "withdrawalDay",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "养殖模式",
                "min-width": "120",
                field: "breedingModeView",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "最新检测时间",
                "min-width": "120",
                field: "lastDetectionTime",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "检测报告",
                "min-width": "120",
                field: "createDate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.onGrade(scope.row)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交人",
                "min-width": "120",
                field: "submitUser",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: { title: "", visible: _vm.fileleDialog, width: "60%" },
            on: {
              "update:visible": function ($event) {
                _vm.fileleDialog = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("检测报告"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.fileleDialog
              ? _c("fileleDialog", { attrs: { fileList: _vm.fileList } })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }